// extracted by mini-css-extract-plugin
export default {"conversation":"conversationBody_conversation__+JEB+"};